import { worldBuildingConfig } from "@monsterverse/world-building-configuration";

import { isWorldBuildingPrototypeEnabled } from "../worldBuilding/configHelpers";
import { IslandType } from "./IslandType";

export function getIslandType(groupId: string): IslandType {
  if (groupId.startsWith("community-")) {
    return IslandType.Home;
  }
  return IslandType.Class;
}

export function getDefaultIslandScene(groupId: string) {
  switch (getIslandType(groupId)) {
    case IslandType.Class: {
      if (isWorldBuildingPrototypeEnabled()) {
        return worldBuildingConfig.scene;
      }

      return "MainDojoIsland";
    }
    case IslandType.Home:
      return "HomeDojoIsland";
  }
}

export function getServerRoomName(groupId: string) {
  switch (getIslandType(groupId)) {
    case IslandType.Class:
      return "class";
    case IslandType.Home:
      return "home";
  }
}
